import { render, staticRenderFns } from "./Select-transports.vue?vue&type=template&id=3b584db0"
import script from "./Select-transports.vue?vue&type=script&lang=js"
export * from "./Select-transports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports